"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = FormContainer;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _ContentLayout = require("../../../../components/ContentLayout");
var _validation = require("../../../../utils/validation");
var _ConfirmationSmsCodeForm = require("../../../../components/ConfirmationSmsCodeForm");
var _registration = require("../../../../types/registration");
var _view = require("../../../../types/view");
var _sentEmail = require("../../../../types/sentEmail");
var _index = require("../../../../../index");
var _tracking = require("../../../../utils/tracking");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RESEND_TIMEOUT = 60;
function FormContainer(_ref) {
  let {
    sendSmsStatus,
    isSubmitting,
    phone,
    email,
    source,
    hasCodeError,
    codeError,
    sendSms,
    changeView,
    confirmPhone,
    emit
  } = _ref;
  const prevSendValidationCodeStatus = React.useRef(sendSmsStatus);
  // FORM
  const [touched, setTouched] = React.useState(false);
  const [changed, setChanged] = React.useState(false);

  //REQUIRED ARGS

  // CODE
  const codeRef = React.useRef(null);
  const [code, setCode] = React.useState('');
  const isCodeInvalid = React.useMemo(() => code === '' || code !== '' && !(0, _validation.isValidCode)(code), [code]);
  const [lastAttemptTimestamp, setLastAttemptTimestamp] = React.useState(new Date().getTime());
  const [resendAvailable, setResendAvailable] = React.useState(false);
  const validateCode = React.useCallback(code => {
    if (!(0, _validation.isValidCode)(code)) {
      if (codeRef.current) {
        codeRef.current.focus();
      }
      return;
    }
    confirmPhone({
      email,
      phone,
      code,
      source
    });
    emit(_index.EEventType.ConfirmPhoneConfirmClick);
    setChanged(false);
  }, [confirmPhone, email, phone, source, emit]);
  const handleChangeCode = React.useCallback(e => {
    const {
      value
    } = e.currentTarget;
    const newValue = value.replace(/\D/gi, '');
    if (newValue.length > 4) {
      return;
    }
    setChanged(true);
    setCode(newValue);
    validateCode(newValue);
  }, [validateCode]);
  const handleTimeoutExpired = React.useCallback(() => {
    setResendAvailable(true);
  }, []);
  const handleResendClick = React.useCallback(e => {
    e.preventDefault();
    if (sendSmsStatus !== _registration.ESendSmsStatus.Succeed) {
      return;
    }
    (0, _tracking.trackConfirmPhoneResendClick)(source);
    emit(_index.EEventType.ConfirmPhoneResendClick);
    sendSms({
      email,
      phone
    });
    setCode('');
    if (codeRef.current) {
      codeRef.current.focus();
    }
  }, [sendSmsStatus, emit, sendSms, email, phone, source]);

  // FORM
  const handleSubmit = React.useCallback(() => {
    (0, _tracking.trackConfirmPhoneConfirmClick)(source);
    setTouched(true);
    validateCode(code);
  }, [validateCode, code, source]);
  const skipConfirmation = React.useCallback(() => {
    changeView(_view.EActiveView.EmailSent, {
      type: _sentEmail.ESentEmailType.Registration,
      email
    });
    emit(_index.EEventType.ConfirmPhoneCancelClick);
  }, [email, emit, changeView]);
  React.useEffect(() => {
    if (prevSendValidationCodeStatus.current !== sendSmsStatus) {
      if (sendSmsStatus === _registration.ESendSmsStatus.Failed) {
        setLastAttemptTimestamp(null);
      } else if (sendSmsStatus === _registration.ESendSmsStatus.Succeed) {
        setLastAttemptTimestamp(new Date().getTime());
      }
      setResendAvailable(false);
    }
    prevSendValidationCodeStatus.current = sendSmsStatus;
  }, [sendSmsStatus]);
  React.useEffect(() => {
    if (codeRef.current) {
      codeRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement(_ConfirmationSmsCodeForm.ConfirmationSmsCodeForm
  //FORM
  , {
    isSubmitting: isSubmitting,
    handleSubmit: handleSubmit,
    submitButtonText: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"
    //CODE
    ,
    codeRef: codeRef,
    code: code,
    onCodeChange: handleChangeCode,
    codeError: !changed && codeError || undefined,
    isCodeInvalid: touched && (isCodeInvalid || !changed && hasCodeError),
    resendAvailable: resendAvailable,
    resendTimeout: RESEND_TIMEOUT,
    lastResendTime: lastAttemptTimestamp,
    onResendTimeoutExpired: handleTimeoutExpired,
    onResend: handleResendClick,
    buttons: /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "SkipPhoneConfirmationBtn",
      theme: "fill_white_primary",
      fullWidth: true,
      onClick: skipConfirmation
    }, "\u0421\u0434\u0435\u043B\u0430\u044E \u043F\u043E\u0437\u0436\u0435")
  }));
}